const inline = (s, k) =>
  s.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? <strong key={`${k}-${i}`} className="text-[#F6EEDC] font-semibold">{part.slice(2, -2)}</strong> : part);

const cells = (row) => row.replace(/^\||\|$/g, "").split("|").map((c) => c.trim());

const Table = ({ rows, k }) => {
  const body = rows.filter((r) => !/^\|?\s*:?-{2,}/.test(r));
  const [head, ...rest] = body.map(cells);
  return (
    <div data-lenis-prevent className="overflow-x-auto my-2">
      <table className="w-full text-xs border-collapse">
        <thead><tr>{(head || []).map((c, i) => <th key={i} className="text-left font-mono-d text-[#F2B441] border-b border-[#F2B441]/40 px-2 py-1.5">{inline(c, `${k}h${i}`)}</th>)}</tr></thead>
        <tbody>{rest.map((r, ri) => <tr key={ri}>{r.map((c, ci) => <td key={ci} className="border-b border-[#F6EEDC]/10 px-2 py-1.5">{inline(c, `${k}${ri}${ci}`)}</td>)}</tr>)}</tbody>
      </table>
    </div>
  );
};

export const Markdown = ({ text }) => {
  const lines = (text || "").split("\n");
  const blocks = [];
  lines.forEach((l) => {
    const t = l.trim();
    const last = blocks[blocks.length - 1];
    if (t.startsWith("|")) {
      if (Array.isArray(last)) last.push(t);
      else blocks.push([t]);
    } else blocks.push(t);
  });
  return (
    <div className="text-sm text-[#E3EADF] leading-relaxed space-y-2">
      {blocks.map((t, i) => {
        if (Array.isArray(t)) return <Table key={i} rows={t} k={i} />;
        if (!t) return null;
        if (/^#{1,4}\s/.test(t)) return <p key={i} className="font-serif-d text-2xl text-[#F2B441] pt-2">{t.replace(/^#+\s/, "")}</p>;
        if (/^[-*•]\s/.test(t)) return <p key={i} className="pl-4 relative before:content-[''] before:absolute before:left-0 before:top-[0.6em] before:w-1.5 before:h-1.5 before:rounded-full before:bg-[#8CD05A]">{inline(t.replace(/^[-*•]\s/, ""), i)}</p>;
        if (/^\d+\.\s/.test(t)) return <p key={i} className="pl-1">{inline(t, i)}</p>;
        if (/^---+$/.test(t)) return <hr key={i} className="border-[#8CD05A]/15" />;
        return <p key={i}>{inline(t, i)}</p>;
      })}
    </div>
  );
};
